import { AffectedStaffDailyReport } from '../../lib/types/models/affectedStaff/affected-staff-daily-report'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffDailyReport(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.getAffectedStaffDailyReport.url, {
        id: affectedStaffId
      })
    )
    .get<AffectedStaffDailyReport>()
}
